import { SELECTED_CLASSNAME } from "./constants.js";
const listItemStyles = {
  iconBoxColors: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    color: "var(--default-color)",
    "@media(hover:hover)": {
      "button:hover &": {
        color: "var(--hover-color)"
      }
    },
    [`button:active &, .${SELECTED_CLASSNAME} &`]: {
      color: "var(--active-color)"
    },
    "button:disabled & ": {
      color: "var(--disabled-color)"
    }
  },
  containerColors: {
    "--default-color": (t) => t.palette.ddrow.content.default,
    "--hover": (t) => t.palette.ddrow.bg.hover,
    "--active": (t) => t.palette.ddrow.bg.active,
    "--hover-color": (t) => t.palette.ddrow.content.hover,
    "--active-color": (t) => t.palette.ddrow.content.active,
    "--disabled-color": (t) => t.palette.ddrow.content.disabled,
    "--hover-selected-bg": (t) => t.palette.ddrow.bg.hover,
    "svg path": {
      fill: "currentColor"
    },
    border: "none",
    "@media(hover:hover)": {
      "&:hover": {
        backgroundColor: "var(--hover)",
        "*": { color: "var(--hover-color)" }
      },
      [`&.${SELECTED_CLASSNAME}:hover`]: {
        backgroundColor: "var(--hover-selected-bg)",
        "*": { color: "var(--hover-color)" }
      }
    },
    [`&:active, &.${SELECTED_CLASSNAME}`]: {
      backgroundColor: "var(--active)",
      "*": { color: "var(--active-color)" }
    },
    "&:disabled": {
      backgroundColor: (t) => t.palette.common.white,
      cursor: "default",
      pointerEvents: "none",
      "*": {
        color: "var(--disabled-color)"
      }
    }
  },
  containerParameters: {
    display: "flex",
    justifyContent: "initial",
    flexDirection: "row",
    backgroundColor: "transparent",
    alignItems: "flex-start",
    cursor: "pointer",
    gap: 12
  },
  content: {
    minWidth: 100,
    textAlign: "start",
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }
}, listItemSizeStyles = {
  iconBoxSizes: {
    md: {
      height: 18
    },
    lg: {
      height: 24
    }
  },
  iconBoxSizesEndAdornment: {
    md: {
      height: 18
    },
    lg: {
      height: 18
    }
  },
  containerSizes: {
    md: {
      minHeight: 42,
      width: "100%",
      boxSizing: "border-box",
      paddingX: 12,
      paddingY: 12
    },
    lg: {
      minHeight: 48,
      width: "100%",
      boxSizing: "border-box",
      paddingX: 12,
      paddingY: 12
    }
  }
};
export {
  listItemSizeStyles,
  listItemStyles
};
//# sourceMappingURL=listItemStyles.js.map
